import { render } from "./modal_point_article_parbon.vue?vue&type=template&id=0ca5c534&scoped=true"
import script from "./modal_point_article_parbon.vue?vue&type=script&lang=js"
export * from "./modal_point_article_parbon.vue?vue&type=script&lang=js"

import "./modal_point_article_parbon.vue?vue&type=style&index=0&id=0ca5c534&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca5c534"]])

export default __exports__